import { config } from '../../../config';
import type { ExchangeRates } from '../types';

export const fetchExchangeRates = async (token: string, currency: string): Promise<ExchangeRates | null> => {
  try {
    const url = new URL(`${config.GATEWAY_URL}/api/admin/exchange-rates`);
    url.searchParams.set('currency', currency);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as
      | ExchangeRates
      | Record<string, { fromCurrency: string; toCurrency: string; midpoint: number }>;

    if (!data) return null;

    if (typeof data.USD === 'object' && 'midpoint' in data.USD) {
      const normalized: ExchangeRates = {};
      Object.entries(data).forEach(([key, value]) => {
        normalized[key] = typeof value === 'object' && 'midpoint' in value ? value.midpoint : (value as number);
      });
      return normalized;
    }

    return data as ExchangeRates;
  } catch (error) {
    console.error('Error fetching exchange rates:', error);
    return null;
  }
};
